import user from '../../../helpers/user';
import h, { getCountry } from '../../../helpers/common';

export const isGamificationEnabled = () => {
    const config = h.getAppConfig();
    const userInfo = user.getUserInfo();
    const operator = userInfo?.operator;

    // Use provided config or fallback to localStorage for backward compatibility
    const configs = config;

    if (!configs || !configs.gamificationConfigs || !configs.operators) {
        return { enable: false };
    }

    const gamificationConfigs = configs.gamificationConfigs;
    const operatorsConfig = configs.operators;

    const userOperator = (operator || '').toLowerCase();
    if (!userOperator) {
        return { enable: false };
    }

    // Check if user's country is allowed
    const { allowedCountriesConfig } = gamificationConfigs;
    const userCountry = getCountry();
    const isCountryAllowed = allowedCountriesConfig?.enable
        ? allowedCountriesConfig.countries.includes(userCountry)
        : false;

    if (!gamificationConfigs.enableGamification || !isCountryAllowed) {
        return { enable: false };
    }

    // Normalize operator keys to lowercase
    const normalizedOperators = Object.entries(operatorsConfig).reduce((acc, [key, value]) => {
        acc[key.toLowerCase()] = value;
        return acc;
    }, {} as Record<string, any>);

    const userOperatorConfig = normalizedOperators[userOperator];
    if (!userOperatorConfig || !userOperatorConfig.gamification) {
        return { enable: false };
    }

    return userOperatorConfig.gamification;
};
